import classNames from "classnames";
import { LowOpacityButton, Tooltip } from "@alchemy/ui";
import { Discord, MessageChat01, Star02 } from "@alchemy/ui/icons/16";

import useTeamSupportUrl from "../../../react-query/queries/useTeamSupportUrl";
import { useState } from "react";
import FeedbackModal from "./FeedbackModal";

interface NavFooterProps {
  onHideOverlay?: () => void;
  onHover?: () => void;
  compact?: boolean;
}

const NavFooter = ({ onHideOverlay, onHover, compact }: NavFooterProps) => {
  const [isFeedbackModalOpen, setIsFeedbackModalOpen] = useState(false);
  const teamSupport = useTeamSupportUrl();

  const supportButtonLabel = teamSupport.data?.isVip
    ? "VIP Support"
    : "Discord Support";
  const feedbackButtonLabel = "Feedback";
  const ButtonIcon = teamSupport.data?.isVip ? MessageChat01 : Discord;

  const showLabels = !!onHideOverlay || !compact;

  return (
    <footer
      className={classNames(
        "relative z-20 flex flex-col gap-2  pb-5 pt-1 transition",
        teamSupport.data ? "" : "opacity-0",
        compact ? "px-2" : "px-4",
      )}
    >
      <Tooltip
        content={feedbackButtonLabel}
        withArrow
        side="right"
        sideOffset={8}
        disabled={showLabels}
      >
        <LowOpacityButton
          aria-label={feedbackButtonLabel}
          icon={<Star02 />}
          className="flex w-full justify-center overflow-hidden whitespace-nowrap"
          onClick={() => setIsFeedbackModalOpen(true)}
          onMouseEnter={onHover}
        >
          {showLabels ? feedbackButtonLabel : undefined}
        </LowOpacityButton>
      </Tooltip>

      <Tooltip
        content={supportButtonLabel}
        withArrow
        side="right"
        sideOffset={8}
        disabled={showLabels}
      >
        <LowOpacityButton
          as="a"
          target="_blank"
          aria-label={supportButtonLabel}
          href={teamSupport.data?.url}
          icon={<ButtonIcon />}
          className="flex w-full justify-center overflow-hidden whitespace-nowrap"
          onClick={onHideOverlay}
          onMouseEnter={onHover}
        >
          {showLabels ? supportButtonLabel : undefined}
        </LowOpacityButton>
      </Tooltip>

      <FeedbackModal
        isOpen={isFeedbackModalOpen}
        onClose={() => setIsFeedbackModalOpen(false)}
      />
    </footer>
  );
};

export default NavFooter;
